export function slugifyHeading(text) {
  return (text || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

/**
 * Build the ebook table of contents from the content dynamic zone.
 * The TOC is generated purely from EbookChapter blocks — each becomes a numbered
 * entry with an anchor derived from its title. Chapters are numbered by order
 * unless an explicit chapterNumber is set.
 *
 * @param {Array} content - ebook content dynamic-zone blocks
 * @returns {Array<{ id: string, anchor: string, number: string, label: string }>}
 */
export function buildEbookToc(content) {
  if (!Array.isArray(content)) return [];

  const items = [];
  let chapterIndex = 0;

  content.forEach((block, blockIndex) => {
    if (!block || block.__typename !== 'ComponentEbookChapter') return;
    // Chapter title is aliased to `chapterTitle` in the GraphQL query to avoid a
    // union field-type conflict with the other (nullable) block titles.
    const chapterTitle = block.chapterTitle || block.title;
    if (!chapterTitle) return;

    chapterIndex += 1;
    const explicit = block.chapterNumber && String(block.chapterNumber).trim();
    const number = explicit || String(chapterIndex).padStart(2, '0');
    const anchor = slugifyHeading(chapterTitle) || `chapter-${blockIndex}`;

    items.push({
      id: block.id,
      index: chapterIndex - 1,
      anchor,
      number,
      label: chapterTitle
    });
  });

  return items;
}
